/**
 * <footer-component> — exposes the rendered footer height as a CSS variable
 * (`--footer-height`) for sibling layout calcs (e.g. main-search min-height).
 *
 * NOTE: a previous scroll "parallax" translated the whole footer upward, but
 * because the footer has an opaque background it covered the bottom of the last
 * section (looked like "the last section goes under the footer"). It's removed.
 *
 * Loaded ONLY from `sections/main-footer.liquid` via
 * `type="module" fetchpriority="low"`.
 */

class FooterComponent extends HTMLElement {
  connectedCallback() {
    this.setFooterHeightVar();
  }

  // Expose the rendered footer height for layout calcs. Deferred to the next
  // frame so we don't force a sync layout during the custom-element upgrade.
  setFooterHeightVar() {
    requestAnimationFrame(() => {
      document.documentElement.style.setProperty('--footer-height', `${this.offsetHeight}px`);
    });
  }
}

if (!customElements.get('footer-component')) {
  customElements.define('footer-component', FooterComponent);
}
